import { HttpErrorResponse, HttpEvent } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { BudgetCategoryDOtherCosts } from '../../../features/feature-budget/models/interfaces/budget-category-d-data.interface'
import { BudgetCostsPerWp } from '../../../features/feature-budget/models/interfaces/budget-costs-per-wp.interface'
import { BudgetEffort } from '../../../features/feature-budget/models/interfaces/budget-effort.interface'
import { BudgetExportFileType } from '../../../features/feature-budget/models/interfaces/budget-export.interface'
import { BudgetIncome } from '../../../features/feature-budget/models/interfaces/budget-income.interface'
import {
   BudgetJustificationOfCostsRequest,
   BudgetJustificationOfCostsResult
} from '../../../features/feature-budget/models/interfaces/budget-justification-of-costs.interface'
import { BudgetJustificationPartner } from '../../../features/feature-budget/models/interfaces/budget-justification-partner.interface'
import { BudgetSalary } from '../../../features/feature-budget/models/interfaces/budget-salary.interface'
import { BudgetStaffEffort } from '../../../features/feature-budget/models/interfaces/budget-staff-effort.interface'
import { BudgetWorkPackage } from '../../../features/feature-budget/models/interfaces/budget-workpackage.interface'
import { BudgetWpWeight } from '../../../features/feature-budget/models/interfaces/budget-wp-weight.interface'

export const loadSalary = createAction('[budget] loadSalary')

export const loadSalarySuccess = createAction('[budget] loadSalarySuccess', props<{ response: BudgetSalary }>())

export const loadSalaryFailed = createAction('[budget] loadSalaryFailed', props<{ error: HttpErrorResponse }>())

export const updateSalary = createAction('[budget] updateSalary', props<{ data: BudgetSalary }>())

export const updateSalarySuccess = createAction('[budget] updateSalarySuccess', props<{ response: BudgetSalary }>())

export const updateSalaryFailed = createAction('[budget] updateSalaryFailed', props<{ error: HttpErrorResponse }>())

export const clearSalary = createAction('[budget] clearSalary')

export const loadEffort = createAction('[budget] loadEffort')

export const loadEffortSuccess = createAction('[budget] loadEffortSuccess', props<{ response: BudgetEffort }>())

export const loadEffortFailed = createAction('[budget] loadEffortFailed', props<{ error: HttpErrorResponse }>())

export const updateEffort = createAction('[budget] updateEffort', props<{ data: BudgetEffort }>())

export const updateEffortSuccess = createAction('[budget] updateEffortSuccess', props<{ response: BudgetEffort }>())

export const updateEffortFailed = createAction('[budget] updateEffortFailed', props<{ error: HttpErrorResponse }>())
export const clearEffort = createAction('[budget] clearEffort')

export const loadIncome = createAction('[budget] loadIncome')

export const loadIncomeSuccess = createAction('[budget] loadIncomeSuccess', props<{ response: BudgetIncome[] }>())

export const loadIncomeFailed = createAction('[budget] loadIncomeFailed', props<{ error: HttpErrorResponse }>())

export const updateIncome = createAction('[budget] updateIncome', props<{ data: BudgetIncome[] }>())

export const updateIncomeSuccess = createAction('[budget] updateIncomeSuccess', props<{ response: BudgetIncome[] }>())

export const updateIncomeFailed = createAction('[budget] updateIncomeFailed', props<{ error: HttpErrorResponse }>())
export const clearIncome = createAction('[budget] clearIncome')

export const loadStaffEffort = createAction('[budget] loadStaffEffort')

export const loadStaffEffortSuccess = createAction('[budget] loadStaffEffortSuccess', props<{ response: BudgetStaffEffort[] }>())

export const loadStaffEffortFailed = createAction('[budget] loadStaffEffortFailed', props<{ error: HttpErrorResponse }>())

export const exportStaffEffort = createAction('[budget] exportStaffEffort', props<{ fileType: BudgetExportFileType }>())

export const exportStaffEffortSuccess = createAction('[budget] exportStaffEffortSuccess', props<{ response: HttpEvent<Blob> }>())

export const exportStaffEffortFailed = createAction('[budget] exportStaffEffortFailed', props<{ error: HttpErrorResponse }>())
export const clearStaffEffort = createAction('[budget] clearStaffEffort')

export const exportPpsForms = createAction('[budget] exportPpsForms', props<{ fileType: BudgetExportFileType }>())

export const exportPpsFormsSuccess = createAction('[budget] exportPpsFormsSuccess', props<{ response: HttpEvent<Blob> }>())

export const exportPpsFormsFailed = createAction('[budget] exportPpsFormsFailed', props<{ error: HttpErrorResponse }>())
export const clearPpsForms = createAction('[budget] clearPpsForms')

export const loadWpWeight = createAction('[budget] loadWpWeight')

export const loadWpWeightSuccess = createAction('[budget] loadWpWeightSuccess', props<{ response: BudgetWpWeight[] }>())

export const loadWpWeightFailed = createAction('[budget] loadWpWeightFailed', props<{ error: HttpErrorResponse }>())

export const exportWpWeight = createAction('[budget] exportWpWeight', props<{ fileType: BudgetExportFileType }>())

export const exportWpWeightSuccess = createAction('[budget] exportWpWeightSuccess', props<{ response: HttpEvent<Blob> }>())

export const exportWpWeightFailed = createAction('[budget] exportWpWeightFailed', props<{ error: HttpErrorResponse }>())

export const clearWpWeight = createAction('[budget] clearWpWeight')

export const loadWorkPackage = createAction('[budget] loadWorkPackage')

export const loadWorkPackageSuccess = createAction('[budget] loadWorkPackageSuccess', props<{ response: BudgetWorkPackage[] }>())

export const loadWorkPackageFailed = createAction('[budget] loadWorkPackageFailed', props<{ error: HttpErrorResponse }>())

export const clearWorkPackage = createAction('[budget] clearWorkPackage')

export const loadCostsWp = createAction('[budget] loadCostsWp', props<{ workPackageId: number }>())

export const loadCostsWpSuccess = createAction('[budget] loadCostsWpSuccess', props<{ response: BudgetCostsPerWp[] }>())

export const loadCostsWpFailed = createAction('[budget] loadCostsWpFailed', props<{ error: HttpErrorResponse }>())

export const updateCostsWp = createAction('[budget] updateCostsWp', props<{ workPackageId: number; data: BudgetCostsPerWp[] }>())

export const updateCostsWpSuccess = createAction('[budget] updateCostsWpSuccess', props<{ response: BudgetCostsPerWp[] }>())

export const updateCostsWpFailed = createAction('[budget] updateCostsWpFailed', props<{ error: HttpErrorResponse }>())

export const clearCostsWp = createAction('[budget] clearCostsWp')

export const loadPartner = createAction('[budget] loadPartner')

export const loadPartnerSuccess = createAction('[budget] loadPartnerSuccess', props<{ response: BudgetJustificationPartner[] }>())

export const loadPartnerFailed = createAction('[budget] loadPartnerFailed', props<{ error: HttpErrorResponse }>())

export const updatePartnerStatus = createAction('[budget] updatePartnerStatus', props<{ partnerId: number; status: string }>())

export const updatePartnerStatusSuccess = createAction('[budget] updatePartnerStatusSuccess')

export const updatePartnerStatusFailed = createAction('[budget] updatePartnerStatusFailed', props<{ error: HttpErrorResponse }>())
export const clearPartner = createAction('[budget] clearPartner')

export const updateBudgetJustificationOfCosts = createAction(
   '[budget] updateBudgetJustificationOfCosts',
   props<{ partnerId: number; data: BudgetJustificationOfCostsRequest[] }>()
)

export const updateBudgetJustificationOfCostsSuccess = createAction('[budget] updateBudgetJustificationOfCostsSuccess')

export const updateBudgetJustificationOfCostsFailed = createAction('[budget] updateBudgetJustificationOfCostsFailed', props<{ error: HttpErrorResponse }>())

export const clearCostsJustif = createAction('[budget] clearCostsJustif')

export const exportCostsJustif = createAction('[budget] exportCostsJustif', props<{ fileType: BudgetExportFileType }>())

export const exportCostsJustifSuccess = createAction('[budget] exportCostsJustifSuccess', props<{ response: HttpEvent<Blob> }>())

export const exportCostsJustifFailed = createAction('[budget] exportCostsJustifFailed', props<{ error: HttpErrorResponse }>())

export const closeExportProgress = createAction('[budget] closeExportProgress')

export const loadBudgetJustificationOfCosts = createAction('[budget] loadBudgetJustificationOfCosts', props<{ partnerId: number }>())

export const loadBudgetJustificationOfCostsSuccess = createAction(
   '[budget] loadBudgetJustificationOfCostsSuccess',
   props<{ response: BudgetJustificationOfCostsResult }>()
)

export const loadBudgetJustificationOfCostsFailed = createAction('[budget] loadBudgetJustificationOfCostsFailed', props<{ error: HttpErrorResponse }>())

export const loadBudgetCategoryDOtherCosts = createAction('[budget] loadBudgetCategoryDOtherCosts', props<{ workpackageId?: number }>())

export const loadBudgetCategoryDOtherCostsSuccess = createAction(
   '[budget] loadBudgetCategoryDOtherCostsSuccess',
   props<{ response: BudgetCategoryDOtherCosts[] }>()
)

export const loadBudgetCategoryDOtherCostsFailed = createAction('[budget] loadBudgetCategoryDOtherCostsFailed', props<{ error: HttpErrorResponse }>())

export const putBudgetCategoryDOtherCosts = createAction(
   '[budget] putBudgetCategoryDOtherCosts',
   props<{ workpackageId: number; data: Partial<BudgetCategoryDOtherCosts>[] }>()
)

export const putBudgetCategoryDOtherCostsSuccess = createAction('[budget] putBudgetCategoryDOtherCostsSuccess')

export const putBudgetCategoryDOtherCostsFailed = createAction('[budget] putBudgetCategoryDOtherCostsFailed', props<{ error: HttpErrorResponse }>())
